import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {computed, ref} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import {__} from "~/ts/library/Translate";
import DialogAssigneeSelect from "~/operatorApplication/vue/dialogs/dialog/sidemenu/DialogAssigneeSelect.vue";
import {DialogAssigneeSelectModelInterface} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/Interface";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ChangeDialogStatusDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    statusId: {}
  }, {
    "visible": { type: Boolean, ...{
    required: true
} },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let visibleModel = _useModel<boolean>(__props, "visible");

let site = computed(() => {
    return OperatorAccountStore.sitesDictionary.value[props.userdata.siteId];
});

let status = computed(() => {
    return site.value?.dialogStatusList.find(status => status.id == props.statusId);
});

let title = computed(() => {
    return __('Изменение статуса диалога на "%s"', status.value?.descr);
})

let assignedDialog = ref<{
    visible: boolean,
    model: {
        assigned: DialogAssigneeSelectModelInterface,
    },
    p: OperatorApplicationApi.OperatorMessageSetDialogStatusOpenApiModel
}>();


async function changeDialogStatus(statusId: string) {
    if (site.value) {
        let dialog = props.userdata.lastDialog;
        if (dialog) {
            let status = site.value.dialogStatusList.find(item => item.id == statusId);
            let p: OperatorApplicationApi.OperatorMessageSetDialogStatusOpenApiModel = {
                username: props.userdata.username,
                dialogId: props.userdata.lastDialog.id,
                statusId
            };

            if (status?.isNeedToSetAssignedOnStatusChange) {
                let hasDefaultAssigned = status.defaultAssignedOperatorLogins.length || status.defaultAssignedOperatorGroupIds.length;
                assignedDialog.value = {
                    visible: true,
                    model: {
                        assigned: {
                            operatorLogins: hasDefaultAssigned ? [...status.defaultAssignedOperatorLogins] : [...dialog.assigned.operatorLogins],
                            groupIds: hasDefaultAssigned ? [...status.defaultAssignedOperatorGroupIds] : [...dialog.assigned.groupIds]
                        }
                    },
                    p
                }
            } else {
                sendRequest(p);
            }
            return;
        }
    }
    visibleModel.value = false;
}

async function sendRequest(p: OperatorApplicationApi.OperatorMessageSetDialogStatusOpenApiModel) {
    let dialog = props.userdata.lastDialog;
    let prevStatusId = dialog.statusId;
    dialog.statusId = p.statusId;
    try {
        let result = await (new OperatorApiRequest({
            url: "/message/setDialogStatus",
            p
        })).send();
        if (result.showMessageOnError()) {
            if (dialog.statusId === p.statusId) {
                dialog.statusId = prevStatusId;
            }
            if (!assignedDialog.value?.visible) {
                visibleModel.value = false;
            }
        } else {
            visibleModel.value = false;
            return;
        }
    } catch (e) {
        if (!assignedDialog.value?.visible) {
            visibleModel.value = false;
        }
        console.error(e);
    }
}

async function onApplyAssignedDialog() {
    let p = assignedDialog.value.p;
    p.assigned = {
        groupIds: assignedDialog.value.model.assigned.groupIds,
        operatorLogins: assignedDialog.value.model.assigned.operatorLogins,
    };
    sendRequest(p);
}

changeDialogStatus(props.statusId);

return (_ctx: any,_cache: any) => {
  return (_unref(assignedDialog) && _unref(assignedDialog).visible)
    ? (_openBlock(), _createBlock(MyDialog, {
        key: 0,
        visible: _unref(assignedDialog).visible,
        "onUpdate:visible": [
          _cache[1] || (_cache[1] = ($event: any) => ((_unref(assignedDialog).visible) = $event)),
          _cache[2] || (_cache[2] = ($event: any) => (_isRef(visibleModel) //@ts-ignore
 ? visibleModel.value = false : visibleModel = false))
        ],
        title: _unref(title),
        onApply: onApplyAssignedDialog
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref(__)("Укажите ответственных, если требуется:")), 1),
          _createElementVNode("p", null, [
            _createVNode(DialogAssigneeSelect, {
              userdata: __props.userdata,
              modelValue: _unref(assignedDialog).model.assigned,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(assignedDialog).model.assigned) = $event))
            }, null, 8, ["userdata", "modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]))
    : _createCommentVNode("", true)
}
}

})